import React, { useContext } from "react";
import LoginForm from "./LoginForm";
import VideoQrScanner from "./VideoQrScanner";
import { SearchContext } from "pages/Search/SearchContext";

const QrScanner = () => {
  const { state: { isAuthenticated } } = useContext(SearchContext);

  return (
    <>
      {
        isAuthenticated ?
          <VideoQrScanner />
          : <LoginForm />
      }
    </>
  )
}
export default QrScanner;
